import { PhotoshopController } from '../../../../photoshopController.js';
import { ParametersWidget } from './parameterWidget.js';
export class Alpha2ColorParameterWidget extends ParametersWidget {
    constructor(parent: HTMLElement, controller: PhotoshopController, operation: any) {
        super(parent, controller);
        this.operation = operation;
        this.parent.innerHTML = Alpha2ColorParameterWidget.html();
        super.initEvent();
    }

    static html() {
        return super.header() +
            `
            <div id="alpha2color" style="padding: 10px;">
            </div>
            ` +
            super.footer();
    }

    reglages_closeOnClick() {
        super.reglages_closeOnClick();
        super.updateIf();
    }
}